module.exports = __webpack_public_path__ + "media/images/social-share-button/xing-5df50dbb4ce5393eab1a3cb7b09c435f.svg";